import { BaseCRUD } from '../CRUD';
import { deleteField, updateField, getVolume } from '../../api/api-project';

export class Field extends BaseCRUD {
	constructor(feature) {
		super();
		Object.keys(feature).forEach((key) => (this[key] = feature[key]));
	}

	get() {}

	create() {}

	update(idField, fieldData) {
		return updateField(idField, fieldData).then((res) => {
			const field = res.data.data;
			Object.keys(field).forEach((key) => (this[key] = field[key]));
		});
	}

	updateVolume(idField, geom) {
		return getVolume(idField, geom).then((res) => {
			const field = res.data.data;
			Object.keys(field).forEach((key) => (this[key] = field[key]));
		});
	}

	async delete(idField, callb) {
		return deleteField(idField).then(() => {
			callb();
		});
	}
}
